export default __webpack_public_path__ + "static/media/c002-PPII-2.672f1ccd.svg";